import { pickValuesFromColorScheme } from '../../../colorUtils';
import { stringLiteralsArray } from '../../../../utils';
export var segmentColorAreas = stringLiteralsArray('foreground');
export var segmentVariables = function segmentVariables(siteVariables) {
  return {
    colorScheme: pickValuesFromColorScheme(siteVariables.colorScheme, segmentColorAreas),
    color: siteVariables.bodyColor,
    disabledColor: siteVariables.colors.grey[250],
    backgroundColor: siteVariables.bodyBackground,
    disabledBackgroundColor: siteVariables.colors.grey[150],
    disabledBorderColor: 'transparent',
    borderRadius: 0,
    borderStyle: 'solid',
    borderWidth: '2px 0 0 0',
    boxShadow: '0 1px 1px 1px rgba(34,36,38,.15)',
    padding: '1em'
  };
};